import * as mutationTypes from './mutation-types'
import '@/store/api/staff-member/typedefs'
import api from '@/store/api/staff-member/role'

const initialState = () => ({
    roles: [],
    categories: [],
    groups: []
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        roles: state => state.roles,
        categories: state => state.categories,
        groups: state => state.groups
    },
    actions: {
        /**
         * @param {ListQuery} params
         * @returns {Promise<*>}
         */
        listRoles: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listRoles(params)
                commit(mutationTypes.SET_ROLES, response.data)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {ListQuery} params
         * @returns {Promise<*>}
         */
        listCategories: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listRoleCategories(params)
                commit(mutationTypes.SET_CATEGORIES, response.data)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {ListQuery} params
         * @returns {Promise<*>}
         */
        listGroups: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listRoleGroups(params)
                commit(mutationTypes.SET_GROUPS, response.data)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetRoles: ({commit}) => commit(mutationTypes.RESET_ROLES),
        resetCategories: ({commit}) => commit(mutationTypes.RESET_CATEGORIES),
        resetGroups: ({commit}) => commit(mutationTypes.RESET_GROUPS)
    },
    mutations: {
        [mutationTypes.RESET_ROLES]: (state) => Object.assign(state.groups, initialState().roles),
        [mutationTypes.SET_ROLES]: (state, data) => state.roles = data,
        [mutationTypes.RESET_CATEGORIES]: (state) => Object.assign(state.groups, initialState().categories),
        [mutationTypes.SET_CATEGORIES]: (state, data) => state.categories = data,
        [mutationTypes.RESET_GROUPS]: (state) => Object.assign(state.groups, initialState().groups),
        [mutationTypes.SET_GROUPS]: (state, data) => state.groups = data
    }
}
